{
	"DefaultSet_Standard_Reports": "Standard Reports",
	"DefaultSet_Power_User_Reports": "Power User Reports",
	"DefaultSet_Contact_Centre_Reports": "Contact Centre Reports",
	"DefaultSet_Call_Center_Reports": "Call Centre Reports",
	"DefaultSet_Enhanced_Call_Center_Reports": "Enhanced Call Centre Reports",
	"DefaultSet_SIP_Reports": "SIP Reports",
	"DefaultSet_Call_Centre_Agent_Reports": "Call Centre Agent Reports",
	"DefaultSet_Essentials_Reports_MST": "CXA Standard Reports",
	"DefaultSet_Professional_Reports_MST": "CXA Unused Reports",
	"DefaultSet_Call_Centre_Agent_Reports_MST": "CXA Premium Reports",
	"NAME": "ReportingDefaultReportSets"
}